export default __webpack_public_path__ + "static/media/account-management.f2070e45.svg";